export const initAuthErrorList: { [key: string]: string } = {
  email: 'incorrect email, please try again',
  username: '',
  gender: '',
  date: '',
  password: '',
  confpassword: 'Make sure both passwords are identical',
};
